module.exports = __webpack_public_path__ + "img/address_hotel.c93e4b21.png";